import { render, staticRenderFns } from "./ChanDoan.vue?vue&type=template&id=70d755da"
import script from "./ChanDoan.vue?vue&type=script&lang=js"
export * from "./ChanDoan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports